import { Paging } from 'api/inc-api.types';

export type AttributeType = 'COLLECTION' | 'TEXT' | 'NUMBER' | 'DATE';

export type CustomerTag = {
  attributeType: AttributeType;
  category: 'CUSTOM' | 'SPEND' | 'DEMOGRAPHICS' | 'OTHER';
  categoryDisplayRank: number;
  categoryDisplayTitle: string;
  clientId: string;
  collectionValues: any;
  description: string;
  id: string;
  key: string;
  source: 'IMPORTED_MANUAL' | 'GUEST_INPUT' | 'SYSTEM';
  sourceDisplayTitle: string;
  tagRank: any;
  tagType: 'CUSTOM' | 'SYSTEM';
  title: string;
  visibility: string[];
};

export type SegmentTargetingFieldType = {
  attributeType: AttributeType;
  collectionValues: any;
  description: string;
  id: string;
  key: string;
  title: string;
  expiredStatus?: boolean;
};

export type CustomerTagMutation = Pick<
  CustomerTag,
  | 'title'
  | 'description'
  | 'source'
  | 'attributeType'
  | 'collectionValues'
  | 'key'
> & { id?: string };

export type GetCustomerTagsResult = {
  paging: Paging;
  tagAndRuleDTOS: CustomerTag[];
};

// phone is used by guest customers
type CustomerPhoneNumber =
  | { phone: string; phoneNumber?: never }
  | { phone?: never; phoneNumber: string };

export type Customer = {
  customerId?: string;
  userId: string;
  mergedPrimaryUserAccountId: string;
  household: string;
  address: string;
  clientId: string;
  firstName: string;
  lastName: string;
  email: string;
  externalId: string;
  baseLanguagePrefrerence: string;
  status: CustomerStatusType;
  howAcquired: string;
  gender: string;
  dateOfBirth: string;
  accountAliasId: string;
  extendedAttributes: Record<string, string>;
  emailBounced: boolean;
  createdDate: string;
  userProfileImageUrl: string;
  blocked: boolean;
  reopened: boolean;
  linked: boolean;
} & CustomerPhoneNumber;

export type CustomerStatusType =
  | 'VERIFIED'
  | 'VERIFICATION_PENDING'
  | 'INCOMPLETE_PROFILE';

export enum AccountChangeLogActionType {
  BLOCKED = 'BLOCKED',
  UNBLOCKED = 'UNBLOCKED',
  LINKED = 'LINKED',
  UNLINKED = 'UNLINKED',
  REOPEN = 'REOPEN',
  DELETED = 'DELETED',
  UPDATED = 'UPDATED',
  AUTO_BLOCKED = 'AUTO_BLOCKED',
  AUTO_FLAGGED = 'AUTO_FLAGGED',
}

export type AccountChangeLogType = {
  adminUserName: string;
  description: string;
  actionType: AccountChangeLogActionType;
  changedDateTime: string;
};
